import { Box } from "@mui/material"
import { useMemo } from "react"
import { useSkills } from "routes/@lib/skills"
import uniqolor from "uniqolor"

export function SkillSetLabel({ skillSetCode }) {
    const [skillsIndex] = useSkills()
    const definition = useMemo(findDefinition, [skillsIndex, skillSetCode])

    if (!definition) {
        return (
            <Box alignSelf="center" sx={{ opacity: 0.5 }} width={38} textAlign="center">
                {skillSetCode}
            </Box>
        )
    }

    return (
        <Box
            p={1}
            minWidth={44}
            borderRadius={1}
            bgcolor={`${uniqolor(definition.Skilling).color}40`}
            textAlign="center"
        >
            {definition.SkillingCode}
        </Box>
    )

    function findDefinition() {
        // Direct lookup by CoreSkillingID (how schedule tasks store it)
        if (skillsIndex[skillSetCode]) return skillsIndex[skillSetCode]
        // Reverse lookup by Skilling name or SkillingCode (how component library stores it)
        return Object.values(skillsIndex).find((s) => s.Skilling === skillSetCode || s.SkillingCode === skillSetCode)
    }
}
